import * as React from 'react';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {PAYROLL_RUN_COLUMNS, type PayrollRunColumnKey} from '../payrollRunColumns';

interface PayrollRunColumnsDialogProps {
    open: boolean;
    onClose: () => void;
    isColumnVisible: (columnId: PayrollRunColumnKey) => boolean;
    handleToggleColumnVisibility: (columnId: PayrollRunColumnKey) => void;
    handleShowAllColumns: () => void;
}

export default function PayrollRunColumnsDialog({
    open,
    onClose,
    isColumnVisible,
    handleToggleColumnVisibility,
    handleShowAllColumns,
}: Readonly<PayrollRunColumnsDialogProps>): React.ReactElement {
    const {t} = useTranslation();

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>{t('payroll.run.columnsDialog.title')}</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" sx={{mb: 1.5, textAlign: 'left'}}>
                    {t('payroll.run.columnsDialog.description')}
                </Typography>
                <List disablePadding>
                    {PAYROLL_RUN_COLUMNS.map((column) => (
                        <ListItemButton
                            key={column.id}
                            onClick={() => handleToggleColumnVisibility(column.id)}
                            dense
                        >
                            <ListItemIcon sx={{minWidth: 36}}>
                                <Checkbox edge="start" checked={isColumnVisible(column.id)} tabIndex={-1} disableRipple/>
                            </ListItemIcon>
                            <ListItemText primary={t(column.labelKey)}/>
                        </ListItemButton>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleShowAllColumns}>{t('payroll.run.columnsDialog.selectAll')}</Button>
                <Button variant="contained" onClick={onClose}>{t('payroll.run.columnsDialog.apply')}</Button>
            </DialogActions>
        </Dialog>
    );
}
